/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled               from 'styled-components';
import { Colours, Spacing } from '../../../styles/variables';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledSiteName = styled.div`
  margin-left: ${Spacing.Tiny};
  width: 80%;
  max-width: 227px;
  color: ${props => props.theme.LogoTextColor || Colours.Tundora};
  position: relative;
  top: 3px;
`;




// WEBPACK FOOTER //
// ./src/components/atoms/StyledSiteName/index.js